import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-24" data-id="element-164" data-mp="30xgghstmwhq5">
      <div className="mx-auto max-w-4xl" data-id="element-165" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-166" data-mp="2w5yfx5viwj5p">
          <h2 className="text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-167" data-mp="2w4wxuhg3aweh">
            <span aria-hidden="true" data-id="element-168" data-mp="2r5aowk7ao2bh">👉 </span>Do You Recognize Yourself in
            These Situations?
          </h2>
          <p className="mt-3 text-sm text-stone-500" data-id="element-169" data-mp="2i6qa3u4uucsj">
            If any of these sound familiar, this kit was made for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-170" data-mp="2d8f1tnu7kacf">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-171" data-mp="289u8m8ddiqxh">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-172" data-mp="bexsmfqfj1fk">
                {item.emoji}
              </span>
              <span className="text-xs font-medium leading-snug text-stone-700" data-id="element-173" data-mp="6f33agmayjwm">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg font-bold italic text-red-500 sm:text-xl" data-id="element-174" data-mp="3nnqfbd534cop">
          There&apos;s a simpler way to prepare →
        </p>
      </div>
    </section>;
}